/**
 * UNIT-EDIT-INFO
 * General infos for the unit (name description)
 */
import ListButton from "@/components/list-button"
import TextInput from "@/components/text-input"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import unitStore from "@/features/risks/entities/unit/model/unit.store"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { t } from "i18next"
import { useState } from "react"
import RiskInrsSideNav from "../../risk/ui/modals/RiskInrsSideNav"
import JobsChips from "../../job/model/ui/JobsChips"

export default function UnitEditInfos() {
  const dispatch = useAppDispatch()

  const draft = useAppSelector(unitStore.selectors.draft)

  const [isInrsOpen, setIsInrsOpen] = useState(false)

  return (
    <div>
      <div className="flex space-x-6">
        <TextInput
          placeholder={t("units_new_name_placeholder_node")}
          title={t("units_name")}
          value={draft.name}
          onChange={(e: any) => dispatch(unitStore.actions.edit({ key: "name", value: e.value }))}
          required
        />

        <TextInput
          min={1}
          type="number"
          title={t("units_size")}
          value={draft.size || ""}
          onChange={(e: any) => {
            const raw = e.value ?? e.target?.value
            const num = raw === "" ? null : Number(raw)
            dispatch(unitStore.actions.edit({ key: "size", value: num === 0 ? null : num }))
          }}
        />
      </div>

      <div className="text-input text-input-fullwidth">
        <div className="text-input-title flex grey-t">{t("units_new_description_node")}</div>
        <textarea
          placeholder={t("units_new_description_placeholder_node")}
          className="text-area"
          value={draft.description}
          onChange={(e) => dispatch(unitStore.actions.edit({ key: "description", value: e.target.value }))}
          rows={4}
        />
      </div>

      <div className="flex flex-col gap-2 flex-1">
        <div className="flex mt-4 gap-2 items-center">
          <div className="grey-t">{t("Métiers concernés")}</div>
          <ListButton
            icon={faSearch}
            text="Explorer les risques"
            color="#9999"
            isRounded
            tooltipPosition="right"
            onClick={() => setIsInrsOpen(true)}
            isOutlineColor
          />
        </div>
        <p className="text-sm text-gray-600">
          {t("Définissez les métiers pour une suggestion des risques adaptée à votre unité")}
        </p>
      </div>

      <JobsChips className="my-5" />

      {isInrsOpen && <RiskInrsSideNav onClose={() => setIsInrsOpen(false)} />}
    </div>
  )
}
